import { get } from "../request-helpers";
import { GetAppVersion, GetGlobalSettings } from "@/server-types";
import { useCustomQuery } from "../custom-query";

export const useGetAppVersion = () => {
  return useCustomQuery({
    queryKey: ["version"],
    queryFn: () => get<GetAppVersion>("/app/version"),
    refetchInterval: 60000,
  });
};

export const useGetGlobalSettings = (disabled?: boolean) => {
  return useCustomQuery({
    queryKey: ["globalSettings"],
    queryFn: () => get<GetGlobalSettings>("/app/global-settings"),
    enabled: !disabled,
  });
};
